import { api } from '@services/api';
import { capitalizeFirstLetter } from '@utils/common';

const servicesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getServices: builder.query<{ id: number; name: string }[], void>({
            query: () => 'public/services/',
            providesTags: ['Services'],
            transformResponse: (response) =>
                (response as { id: number; name: string }[]).map((service) => ({
                    ...service,
                    name: capitalizeFirstLetter(service.name.split('_').join(' ')),
                })),
        }),
    }),
});

export const { useGetServicesQuery } = servicesApi;
export default servicesApi;
